(function installBcPostcodeWaitlistShim() {
  if (window.__bcPostcodeWaitlistShimInstalled) return;
  window.__bcPostcodeWaitlistShimInstalled = true;

  var CHECKER_SELECTOR = '.bc-delivery-checker';
  var INPUT_SELECTOR = '#input_postcode, input.bc-dc__input';
  var MESSAGE_SELECTOR = '[data-bc-postcode-gate-message], [id^="bc-postcode-gate-message-"]';
  var WAITLIST_MODAL_SELECTOR = '#bc-dc-fail-modal, .bc-dc__fail-modal';
  var WAITLIST_POSTCODE_ATTRIBUTE = 'bcDcWaitlistPostcode';
  var KLAVIYO_COMPANY_ID = 'VQeQ2Z';
  var KLAVIYO_LIST_ID = 'VUBUny';

  function installWaitlistStyles() {
    if (document.getElementById('bc-postcode-waitlist-shim-styles')) return;

    var style = document.createElement('style');
    style.id = 'bc-postcode-waitlist-shim-styles';
    style.textContent = [
      '.bc-dc__fail-modal .bc-dc__waitlist-btn {',
      '  -webkit-appearance: none !important;',
      '  appearance: none !important;',
      '  background: #111 !important;',
      '  border: 1px solid #111 !important;',
      '  box-shadow: none !important;',
      '  color: #fff !important;',
      '  outline: none;',
      '}',
      '.bc-dc__fail-modal .bc-dc__waitlist-btn::before,',
      '.bc-dc__fail-modal .bc-dc__waitlist-btn::after {',
      '  content: none !important;',
      '  display: none !important;',
      '  box-shadow: none !important;',
      '}',
      '.bc-dc__fail-modal .bc-dc__waitlist-btn:focus-visible {',
      '  outline: 2px solid #111 !important;',
      '  outline-offset: 3px;',
      '}',
    ].join('\n');
    document.head.appendChild(style);
  }

  function getGateResult(input) {
    var gatekeeper = window.bcDeliveryZoneGatekeeper;
    if (!gatekeeper || typeof gatekeeper.check !== 'function') return null;

    try {
      return gatekeeper.check(input.value);
    } catch (error) {
      return null;
    }
  }

  function isVisible(element) {
    return Boolean(
      element &&
        element.getClientRects &&
        element.getClientRects().length &&
        window.getComputedStyle(element).visibility !== 'hidden'
    );
  }

  function findCheckerInput(checker) {
    if (!checker) return null;

    var inputs = Array.prototype.slice.call(checker.querySelectorAll(INPUT_SELECTOR));
    return inputs.find(isVisible) || inputs[0] || null;
  }

  function isWaitlistModalAction(target) {
    return Boolean(target.closest(WAITLIST_MODAL_SELECTOR));
  }

  function findInputForEvent(event) {
    var target = event.target;
    if (!(target instanceof Element)) return null;
    if (isWaitlistModalAction(target)) return null;

    if (event.type === 'keydown') {
      return target.matches(INPUT_SELECTOR) ? target : null;
    }

    var checker = target.closest(CHECKER_SELECTOR);
    if (!checker) return null;

    if (event.type === 'submit' || target.closest('button, [role="button"], input[type="submit"], input[type="button"]')) {
      return findCheckerInput(checker);
    }

    return null;
  }

  function formatPostcode(raw) {
    var display = String(raw || '').trim().toUpperCase().replace(/\s+/g, '');
    if (display.length > 4) {
      display = display.slice(0, -3) + ' ' + display.slice(-3);
    }
    return display;
  }

  function clearInlineGateFeedback(checker, input) {
    checker.querySelectorAll(MESSAGE_SELECTOR).forEach(function removeMessage(message) {
      message.remove();
    });

    if (input) {
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
      input.classList.remove('bc-postcode-gate-blocked');
    }
  }

  function openUnsupportedPostcodeModal(input, result) {
    var checker = input && input.closest(CHECKER_SELECTOR);
    if (!checker || !result || result.reason !== 'unsupported-zone') return false;

    var postcodeLabel = formatPostcode(result.normalized || input.value);
    clearInlineGateFeedback(checker, input);

    checker
      .querySelectorAll('#bc-dc-fail-postcode, [data-bc-dc-fail-modal-postcode]')
      .forEach(function setPostcodeLabel(element) {
        element.textContent = postcodeLabel;
      });

    var failModal = checker.querySelector(WAITLIST_MODAL_SELECTOR);
    if (!failModal) return false;

    failModal.dataset[WAITLIST_POSTCODE_ATTRIBUTE] = postcodeLabel;
    failModal.classList.add('is-open');
    failModal.setAttribute('aria-hidden', 'false');
    failModal.removeAttribute('hidden');
    document.body.classList.add('bc-dc-modal-open-global');

    window.setTimeout(function focusWaitlistEmail() {
      var emailInput = failModal.querySelector('input[type="email"], .bc-dc__waitlist-input');
      if (emailInput instanceof HTMLInputElement) {
        try {
          emailInput.focus({ preventScroll: true });
        } catch (error) {
          emailInput.focus();
        }
      }
    }, 0);

    checker.dispatchEvent(new CustomEvent('bcDc:unsupportedPostcode', {
      bubbles: true,
      detail: {
        input: input,
        normalized: result.normalized || '',
        outcode: result.outcode || '',
        sector: result.sector || '',
        reason: result.reason || 'unsupported-zone',
      },
    }));

    return true;
  }

  function getModalPostcode(modal) {
    if (!modal) return '';

    var postcode = modal.dataset[WAITLIST_POSTCODE_ATTRIBUTE] || '';
    if (!postcode) {
      var label = modal.querySelector('[data-bc-dc-fail-modal-postcode], #bc-dc-fail-postcode');
      postcode = label ? label.textContent : '';
    }
    return formatPostcode(postcode);
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function setWaitlistStatus(modal, message, isError) {
    var status = modal && modal.querySelector('[data-bc-dc-waitlist-status], .bc-dc__waitlist-status');
    if (!status) return;

    status.textContent = message || '';
    status.classList.remove('is-success');
    if (!isError && message) {
      status.classList.add('is-success');
    }
  }

  function setWaitlistLoading(button, loading) {
    if (!button) return;
    if (!button.dataset.bcDefaultLabel) {
      button.dataset.bcDefaultLabel = (button.textContent || 'Join Wait List').trim();
    }

    button.disabled = Boolean(loading);
    button.textContent = loading ? 'Joining...' : button.dataset.bcDefaultLabel;
  }

  function postKlaviyoWaitlist(email, formattedPostcode) {
    if (!window.fetch) {
      return Promise.reject(new Error('Waitlist signup is not supported in this browser.'));
    }

    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_COMPANY_ID);
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  service_area_status: 'out_of_area',
                  service_area_postcode: formattedPostcode,
                  service_area_source: 'delivery_checker',
                  out_of_wait_list: true,
                  out_of_wait_list_tag: 'out_of_wait_list',
                  service_area_checked_at: new Date().toISOString(),
                },
              },
            },
          },
          custom_source: 'Out of area delivery checker',
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: KLAVIYO_LIST_ID,
            },
          },
        },
      },
    };

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
        revision: '2025-04-15',
      },
      body: JSON.stringify(payload),
      mode: 'cors',
    }).then(function handleWaitlistResponse(response) {
      if (response.ok) return true;

      return response.text().then(function throwWaitlistError(text) {
        throw new Error(text || 'Waitlist request failed: ' + response.status);
      });
    });
  }

  function submitShimWaitlist(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    if (event.type === 'keydown' && event.key !== 'Enter') return;

    var button = target.closest('.bc-dc__waitlist-btn');
    var emailInput = target.matches('.bc-dc__waitlist-input, input[type="email"]') ? target : null;

    if (!button && !emailInput) return;

    var modal = target.closest(WAITLIST_MODAL_SELECTOR);
    if (!modal || !modal.dataset[WAITLIST_POSTCODE_ATTRIBUTE]) return;

    if (!emailInput) {
      emailInput = modal.querySelector('.bc-dc__waitlist-input, input[type="email"]');
    }
    if (!button) {
      button = modal.querySelector('.bc-dc__waitlist-btn');
    }
    if (!(emailInput instanceof HTMLInputElement)) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    var email = (emailInput.value || '').trim().toLowerCase();
    if (!email || !isValidEmail(email)) {
      setWaitlistStatus(modal, 'Please enter a valid email address.', true);
      return;
    }

    var postcode = getModalPostcode(modal);
    if (!postcode) {
      setWaitlistStatus(modal, 'Please check your postcode again.', true);
      return;
    }

    setWaitlistStatus(modal, '', true);
    setWaitlistLoading(button, true);

    postKlaviyoWaitlist(email, postcode)
      .then(function handleWaitlistSuccess() {
        setWaitlistLoading(button, false);
        setWaitlistStatus(modal, "You're on the wait list. We'll let you know when we expand.", false);
      })
      .catch(function handleWaitlistFailure() {
        setWaitlistLoading(button, false);
        setWaitlistStatus(modal, 'Sorry, something went wrong. Please try again.', true);
      });
  }

  function handlePotentialUnsupportedPostcode(event) {
    if (event.type === 'keydown' && event.key !== 'Enter') return;

    var input = findInputForEvent(event);
    if (!(input instanceof HTMLInputElement)) return;

    var result = getGateResult(input);
    if (!result || result.allowed || result.reason !== 'unsupported-zone') return;
    if (!openUnsupportedPostcodeModal(input, result)) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
  }

  installWaitlistStyles();
  window.addEventListener('click', handlePotentialUnsupportedPostcode, true);
  window.addEventListener('submit', handlePotentialUnsupportedPostcode, true);
  window.addEventListener('keydown', handlePotentialUnsupportedPostcode, true);
  window.addEventListener('click', submitShimWaitlist, true);
  window.addEventListener('keydown', submitShimWaitlist, true);
})();
